import { ChatTypeProvideObject } from "@/types/chat";
import { getInjectionKey } from "../app";

export const chatTypeInjectionKey = getInjectionKey<ChatTypeProvideObject>();
